import { render } from "./DaysOffRequests.vue?vue&type=template&id=1c16189b&scoped=true"
import script from "./DaysOffRequests.vue?vue&type=script&lang=js"
export * from "./DaysOffRequests.vue?vue&type=script&lang=js"

import "./DaysOffRequests.vue?vue&type=style&index=0&id=1c16189b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c16189b"]])

export default __exports__